import { render, staticRenderFns } from "./tallySyncStatus.vue?vue&type=template&id=c78feb90&"
import script from "./tallySyncStatus.vue?vue&type=script&lang=js&"
export * from "./tallySyncStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports